<template>
    <div style="display: flex; align-items: center; justify-content: center;">
        <v-container fluid>
            <v-layout row>
                <v-flex style="display: flex; align-items: center; justify-content: center;">
                    <v-card class="card--flex-toolbar" style="width: 900px;">
                        <v-toolbar card dense color="primary" dark>
                        <v-toolbar-title>2018 Total Sales Attribution</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn icon>
                            <v-icon>info</v-icon>
                        </v-btn>
                        </v-toolbar>
                        <v-divider></v-divider>
                        <v-card-text>
                        <v-layout row>
                            <div style="width: 100px; height: 400px; float: left; margin-top: 25px;">
                                <div style="width: 50%; float: left; height: 160px; border-right: 1px dashed #1976d2;"></div>
                                <div style="width: 50%; height: 160px;"></div>
                                <div style="width: 100%; height: 40px; text-align: center; vertical-align: middle; line-height: 20px;">
                                    <b>Total sales</b><br>
                                    {{ formatCurrency(2081280) }}
                                </div>
                                <div style="width: 50%; float: left; height: 250px; border-right: 1px dashed #1976d2;"></div>
                                <div style="width: 50%; height: 250px;"></div>
                            </div>
                            <div style="width: 700px; height: 500px; float: left;">
                                <v-chart :options="options"/>
                                &nbsp;
                            </div>
                            <div style="width: 100px; height: 400px; float: left; margin-top: 25px;">
                                <div style="width: 50%; float: left; height: 160px; border-right: 1px dashed #1976d2;"></div>
                                <div style="width: 50%; height: 160px;"></div>
                                <div style="width: 100%; height: 40px; text-align: center; vertical-align: middle; line-height: 20px;">
                                    <b>Total sales</b><br>
                                    {{ formatCurrency(2081280) }}
                                </div>
                                <div style="width: 50%; float: left; height: 250px; border-right: 1px dashed #1976d2;"></div>
                                <div style="width: 50%; height: 250px;"></div>
                            </div>
                        </v-layout>
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>

<script>
import datasource from '@/data'

import ECharts from 'vue-echarts'
import 'echarts/lib/chart/sankey'
import 'echarts/lib/component/tooltip'
import numbro from 'numbro'

export default {
  components: {
    'v-chart': ECharts
  },
  computed: {
      options: function () {
        var cha = datasource.channels
        var att = datasource.attribution
        var links = att.links
        var data = [{
            name: 'Economy',
            label: {
                formatter: '{b|{b}}',
                rich: {
                    b: {
                        color: '#fff',
                        fontSize: 15,
                        textShadowBlur: 1,
                        textShadowColor: '#000',
                        textShadowOffsetX: 0,
                        textShadowOffsetY: 1,
                        textBorderColor: '#333',
                        textBorderWidth: 2
                    }
                }
            },
            itemStyle: {
                color: '#61a0a8'
            }
        }, {
            name: 'Base',
            label: {
                formatter: '{b|{b}}',
                rich: {
                    b: {
                        color: '#fff',
                        fontSize: 15,
                        textShadowBlur: 1,
                        textShadowColor: '#000',
                        textShadowOffsetX: 0,
                        textShadowOffsetY: 1,
                        textBorderColor: '#333',
                        textBorderWidth: 2
                    }
                }
            },
            itemStyle: {
                color: '#91c7ae'
            }
        }, {
            name: 'Competition',
            label: {
                formatter: '{b|{b}}',
                rich: {
                    b: {
                        color: '#fff',
                        fontSize: 15,
                        textShadowBlur: 1,
                        textShadowColor: '#000',
                        textShadowOffsetX: 0,
                        textShadowOffsetY: 1,
                        textBorderColor: '#333',
                        textBorderWidth: 2
                    }
                }
            },
            itemStyle: {
                color: '#d48265'
            }
        }, {
            name: 'Main',
            label: {
                formatter: '\n\n{a|}',
                rich: {
                    a: {
                        height: 50,
                        width: 50,
                        verticalAlign: 'bottom',
                        backgroundColor: {
                            image: require('@/assets/logo_main.png')
                        }       
                    }
                }
            },
            itemStyle: {
                color: '#6950a1'
            }
        }, {
            name: 'Dessert',
            label: {
                formatter: '\n\n{a|}',
                rich: {
                    a: {
                        height: 50,
                        width: 50,
                        verticalAlign: 'bottom',
                        backgroundColor: {
                            image: require('@/assets/logo_dessert.png')
                        }       
                    }
                }
            },
            itemStyle: {
                color: '#ac6767'
            }
        }, {
            name: 'Breakfast',
            label: {
                formatter: '\n\n{a|}',
                rich: {
                    a: {
                        height: 50,
                        width: 50,
                        verticalAlign: 'bottom',
                        backgroundColor: {
                            image: require('@/assets/logo_breakfast.png')
                        }       
                    }
                }
            },
            itemStyle: {
                color: '#1d953f'
            }
        }]

        for (let index = 0; index < cha.channelNames.length; index++) {
            var logoAvailable = cha.channelLogos[index].length > 0
            data.push({
                name: cha.channelNames[index],
                label: {
                    formatter: '{a|}',
                    rich: {
                        a: {
                            height: 30,
                            width: 30,
                            verticalAlign: 'middle',
                            backgroundColor: {
                                image: require('@/assets/logo_' + cha.channelLogos[index])
                            }       
                        }
                    }
                },
                itemStyle: {
                    color: cha.channelColors[index]
                }
            })
        }
          return {
            tooltip: {
                trigger: 'item',
                triggerOn: 'mousemove',
                //formatter: '{b}<br />${c}'
                formatter: this.formatTooltip
            },
            series: {
                type: 'sankey',
                draggable: false,
                nodeGap: 0,
                layout:'none',
                focusNodeAdjacency: 'allEdges',
                itemStyle: {
                    normal: {
                        borderWidth: 0
                    }
                },
                lineStyle: {
                    normal: {
                        color: 'source',
                        curveness: 0.6
                    }
                },
                data: data,
                links: links
            }
        }
      },
      totals: function () {
          return {
              'Main': 1160990,
              'Dessert': 920290,
              'Breakfast': 920290,
              'Facebook': 355770,
              'Instagram': 355770,
              'TV': 355770,
              'OOH': 355770,  
              'Base': 866440,
              'Economy': 247450,
              'Competition': 255850
          }
      }
  },
  methods: {
      getTotal: function (name) {
          return this.totals[name]
      },
      formatTooltip: function (params) {
          var value = 0
          if (params.value) {
              value = params.value
          } else {
              value = this.getTotal(params.name)
          }
          return(`
            <b>${params.name.replace('>', '→')}</b>
            <br/>
            <span style="color: lightblue; font-size: 18px;">${this.formatCurrency(value)}</span>
          `)
      },
      formatCurrency: function (value) {
          return numbro(value).formatCurrency({
                average: true,
                mantissa: 1,
                optionalMantissa: true
            })
      }
  },
  data () {
    return {
        
    }
  }
}
</script>

<style>
    .echarts {
        width: 100%;
        height: 100%;
    }
</style>
